module.exports = __webpack_public_path__ + "static/media/6-8.031c2773.mp3";